import type { AxiosAdapter } from 'axios';

const adapter: AxiosAdapter | null = null;

export default adapter;
